import type { OktaAuth } from "@okta/okta-auth-js";

let _oktaAuth: OktaAuth | null = null;

/**
 * Registers the OktaAuth singleton. Called once from main.ts during the
 * production-mode bootstrap. Must be called before the router mounts.
 */
export function setOktaAuth(instance: OktaAuth): void {
  _oktaAuth = instance;
}

/**
 * Returns the OktaAuth singleton.
 *
 * Only available in production mode – always guard callers with `IS_DEMO`
 * checks so this is never reached in demo mode.
 */
export function getOktaAuth(): OktaAuth {
  if (!_oktaAuth) {
    throw new Error(
      "OktaAuth is not initialised. " +
        "This should not be called in demo mode or before production bootstrap.",
    );
  }
  return _oktaAuth;
}
